import {
  CandidateImportIcon,
  CandidateImportActiveIcon,
  InterviewNoShow,
  InterviewPanelNoShowIcon,
  InterviewRejectedIcon,
  InterviewResultStatusPendingIcon,
  InterviewScheduledStatusPendingIcon,
  InterviewScheduledIcon,
  InterviewRescheduledIcon,
  InterviewResultPendingIcon,
  InterviewScheduledActiveIcon,
  InterviewScheduledPendingIcon,
  InterviewShortlistedIcon,
  ResumeRejectedIcon,
  ResumeShortlistedIcon,
  ResumeShortlistedActiveIcon,
  ResumeScreeningPendingIcon,
  ResumeStatusPendingIcon,
} from "@assets/Icons";

import { CandidateStatus } from "@cointervue/shared";

export type PipelineStep = {
  step: number;
  statuses: readonly CandidateStatus[];
};

export const PIPELINE_STEPS: readonly PipelineStep[] = [
  {
    step: 1,
    statuses: [CandidateStatus.CANDIDATE_IMPORTED],
  },
  {
    step: 2,
    statuses: [
      CandidateStatus.RESUME_AI_SHORTLISTED,
      CandidateStatus.RESUME_AI_REJECTED,
      CandidateStatus.RESUME_AI_SCREEN_PENDING,
    ],
  },
  {
    step: 3,
    statuses: [
      CandidateStatus.INTERVIEW_SCHEDULED,
      CandidateStatus.INTERVIEW_RESCHEDULED,
      CandidateStatus.INTERVIEW_SCHEDULE_PENDING,
    ],
  },
  {
    step: 4,
    statuses: [
      CandidateStatus.INTERVIEW_SHORTLISTED,
      CandidateStatus.INTERVIEW_REJECTED,
      CandidateStatus.INTERVIEW_NO_SHOW,
      CandidateStatus.INTERVIEW_PANEL_NO_SHOW,
      CandidateStatus.INTERVIEW_RESULT_PENDING,
    ],
  },
] as const;

export type StepState = "active" | "complete" | "pending";

export function resolveStageIcon(
  step: number,
  status: CandidateStatus,
  state: StepState,
) {
  if (step === 1) {
    if (state === "active") return CandidateImportActiveIcon;
    return CandidateImportIcon;
  }

  if (step === 2) {
    if (status === CandidateStatus.RESUME_AI_REJECTED) {
      return ResumeRejectedIcon;
    }
    if (status === CandidateStatus.RESUME_AI_SCREEN_PENDING) {
      return ResumeScreeningPendingIcon;
    }
    if (state === "active") return ResumeShortlistedActiveIcon;
    if (state === "pending") return ResumeStatusPendingIcon;
    return ResumeShortlistedIcon;
  }

  if (step === 3) {
    if (status === CandidateStatus.INTERVIEW_RESCHEDULED) {
      return InterviewRescheduledIcon;
    }
    if (status === CandidateStatus.INTERVIEW_SCHEDULE_PENDING) {
      return InterviewScheduledPendingIcon;
    }

    if (state === "active") return InterviewScheduledActiveIcon;
    if (state === "pending") return InterviewScheduledStatusPendingIcon;

    return InterviewScheduledIcon;
  }

  if (step === 4) {
    if (state === "pending") return InterviewResultStatusPendingIcon;

    switch (status) {
      case CandidateStatus.INTERVIEW_SHORTLISTED:
        return InterviewShortlistedIcon;
      case CandidateStatus.INTERVIEW_REJECTED:
        return InterviewRejectedIcon;
      case CandidateStatus.INTERVIEW_NO_SHOW:
        return InterviewNoShow;
      case CandidateStatus.INTERVIEW_PANEL_NO_SHOW:
        return InterviewPanelNoShowIcon;
      case CandidateStatus.INTERVIEW_RESULT_PENDING:
        return InterviewResultPendingIcon;
    }
  }

  return InterviewResultStatusPendingIcon;
}